import { useState, useEffect } from "react";
import { useDriver } from "@/contexts/driver";
import { useBrandAuth } from "./useBrandAuth";

export const useOnboardingFloatingMenu = () => {
  const [isVisible, setIsVisible] = useState(false);
  const { isTourOpen, setIsTourOpen } = useDriver();
  const { user } = useBrandAuth();

  useEffect(() => {
    // Show floating menu if tour is open and user is authenticated
    if (isTourOpen && user) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  }, [isTourOpen, user]);

  const hideFloatingMenu = () => {
    setIsVisible(false);
    setIsTourOpen(false);
  };

  const showFloatingMenu = () => {
    setIsVisible(true);
    setIsTourOpen(true);
  };

  return {
    isVisible,
    hideFloatingMenu,
    showFloatingMenu,
    isTourOpen,
  };
};
